import { isRequired } from '@nhl/param-helpers';

import TeamsAPI from '../../../utils/teamsAPI';
import gameDataAPI from '../../../utils/gameDataAPI';
import actionCreators from './actionCreators';
import { ACTIVE_SEASON_IDENTIFIER } from './reducers';

const fetchTeamsForLeagueAndSeason = (season = isRequired('season'), league = isRequired('league')) => async dispatch => {
    dispatch(actionCreators.requestTeams());

    try {
        const data = await TeamsAPI.fetchTeamsForLeagueAndSeason({
            season,
            league,
        });
        const sluggedTeams = TeamsAPI.addTeamSlugs(TeamsAPI.getTeamsWithCorrectStats(data.data, false, season));

        dispatch(actionCreators.teamsResponse(true, sluggedTeams, null, season));
    } catch (error) {
        dispatch(actionCreators.teamsResponse(false, [], error, season))
    }
};

const fetchActiveNHLTeams = () => async dispatch => {
    dispatch(actionCreators.requestTeams());

    try {
        const data = await TeamsAPI.fetchActiveNHLTeams();
        const sluggedTeams = TeamsAPI.addTeamSlugs(data.data);

        dispatch(actionCreators.teamsResponse(true, sluggedTeams, null, ACTIVE_SEASON_IDENTIFIER));
    }  catch (error) {
        dispatch(actionCreators.teamsResponse(false, [], error, ACTIVE_SEASON_IDENTIFIER))
    }
}

const fetchTeamLogoAssets = () => async dispatch => {
    dispatch(actionCreators.requestLogoAssets());

    try {
        const data = await TeamsAPI.fetchTeamLogoAssets();
        dispatch(actionCreators.logoAssetsResponse(true, data.data, null))
    } catch (error) {
        dispatch(actionCreators.logoAssetsResponse(false, [], error))
    }
};

const fetchTeamSocialAccounts = () => async dispatch => {
    dispatch(actionCreators.requestTeamSocialAccounts());

    try {
        const data = await TeamsAPI.fetchTeamSocialAccounts();
        dispatch(actionCreators.teamSocialAccountsResponse(true, data.data, null))
    } catch (error) {
        dispatch(actionCreators.teamSocialAccountsResponse(false, [], error))
    }
};

const fetchTeamLogoAssetsBySeason = (season = isRequired('season')) => async dispatch => {
    dispatch(actionCreators.requestLogoAssets());

    try {
        const data = await TeamsAPI.fetchTeamLogoAssetsBySeason({season});
        dispatch(actionCreators.logoAssetsResponse(true, data.data, null))
    } catch (error) {
        dispatch(actionCreators.logoAssetsResponse(false, [], error))
    }
};

const fetchGamesByTeamId = (id = isRequired('id'), minimumGameDate = isRequired('minimumGameDate')) => async dispatch => {
    dispatch(actionCreators.requestGamesForTeam());

    try {
        const data = await gameDataAPI.fetchXNextGamesByTeamId({
            teamId: id,
            minimumGameDate,
            gamesToFetch: 7
        });
        dispatch(actionCreators.gamesForTeamResponse(true, [{id: id, games: data.data}], null))
    } catch (error) {
        dispatch(actionCreators.gamesForTeamResponse(false, [], error))
    }
};

const fetchGameNotesByTeamId = (teamId = isRequired('teamId')) => async dispatch => {
    dispatch(actionCreators.requestGameNotes());

    try {
        const data = await gameDataAPI.fetchGameNotesForTeam({teamId});
        dispatch(actionCreators.gameNotesResponse(true, teamId, data.data, null))
    } catch (error) {
        dispatch(actionCreators.gameNotesResponse(false, teamId, [], error))
    }
};

export default {
    fetchTeamsForLeagueAndSeason,
    fetchActiveNHLTeams,
    fetchGamesByTeamId,
    fetchTeamLogoAssets,
    fetchTeamLogoAssetsBySeason,
    fetchTeamSocialAccounts,
    fetchGameNotesByTeamId,
};
